import { controlToastState } from "risa-oasis-ui_v2";
import {
  getCmmInputDataForOrder,
  sendtoPlanRequest,
} from "../../../api/bigQuery/nycbsPharmaOrders";
import { addCmmEvent } from "../../../api/firebase/firestoreService";
import { mapToCoverMyMedsInputModel } from "../../../data-model/cmmInputRequestModel";
import { CmmEvents } from "../../../enums/cmmEvents";
import { ScreenNames } from "../../../enums/screenNames";

export const executeSendToPlan = async (
  orderId: string,
  userEmail?: string,
  onSuccess?: () => void,
) => {
  try {
    await addCmmEvent(orderId, {
      event: CmmEvents.SEND_TO_PLAN_CLICKED,
      screen_name: ScreenNames.SEND_TO_PLAN_MODAL,
      created_at: new Date(),
      email: userEmail ?? "",
    });

    const orderResponse = await getCmmInputDataForOrder(orderId);
    const orderData = orderResponse?.["details"];

    if (!orderData) {
      throw new Error("Failed to fetch order data");
    }

    const asteraOncologySanityInputData = mapToCoverMyMedsInputModel(orderData);

    await sendtoPlanRequest(
      asteraOncologySanityInputData,
      orderId,
      "cmm-orders-table",
      userEmail ?? "",
    );

    controlToastState("send-to-plan-success");

    if (onSuccess) {
      onSuccess();
    }
  } catch (error) {
    console.error("Error sending to plan:", error);
    controlToastState("send-to-plan-error");
  }
};
